function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.99763 0C6.25797 0 6.47319 0.193386 6.50726 0.444416L6.512 0.514203L6.51282 5.48593H11.4858C11.7698 5.48593 12 5.71621 12 6.00024C12 6.26062 11.8065 6.4758 11.5556 6.50988L11.4858 6.51455H6.51282L6.51419 11.4856C6.51426 11.7696 6.28409 12 6.0001 12C5.73977 12 5.52455 11.8066 5.49047 11.5556L5.48574 11.4858L5.48437 6.51455H0.514224C0.230222 6.51455 0 6.28427 0 6.00024C0 5.73986 0.193451 5.52468 0.444447 5.4906L0.514224 5.48593H5.48437L5.48355 0.514409C5.48348 0.230368 5.71365 0 5.99763 0Z"
});

var SvgIcAssetAdd = function SvgIcAssetAdd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcAssetAdd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_asset_add.d3c7e100.svg";
export { ForwardRef as ReactComponent };